/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Viewings_Open_PropertyInputs */

const cs_viewings_open_property = /** @type {(inputs: Viewings_Open_PropertyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otevřít nemovitost`)
};

const en_viewings_open_property = /** @type {(inputs: Viewings_Open_PropertyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open property`)
};

/**
* | output |
* | --- |
* | "Open property" |
*
* @param {Viewings_Open_PropertyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const viewings_open_property = /** @type {((inputs?: Viewings_Open_PropertyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Viewings_Open_PropertyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_viewings_open_property(inputs)
	return cs_viewings_open_property(inputs)
});